import { getRefreshToken } from '@vgrubs/components';
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.NX_API_URL;

type ObserveProvidersDto = {
  subscribe: boolean;
  brandId: number;
};

const useManageProvidersSocket = ({
  locationId,
  brandId,
  getProvidersStatuses,
}: {
  locationId?: number;
  brandId?: number;
  getProvidersStatuses: (silent?: boolean, buttonLoading?: boolean) => void;
}) => {
  const refreshToken = getRefreshToken();
  const socketRef = useRef<any>(null);

  useEffect(() => {
    if (!refreshToken) return;

    if (socketRef.current && socketRef.current.connected) {
      return;
    }

    const socket = io(SOCKET_URL, {
      path: '/provider',
      transports: ['websocket'],
      auth: {
        authorization: refreshToken,
      },
    });

    socketRef.current = socket;

    socket.on('connection_successful', () => {
      const body = {
        subscribe: true,
        locationId,
        brandId,
      };

      socket.emit('observe-providers', body);
    });

    socket.on('observe-providers', (data: ObserveProvidersDto) => {});

    socket.on('provider_changes', (data: { brandId: number }) => {
      getProvidersStatuses(true, true);
    });

    return () => {
      socket.disconnect();
    };
  }, [refreshToken]);

  return {};
};

export default useManageProvidersSocket;
